module.exports = __webpack_public_path__ + "img/close-circle.d73028e3.svg";